import React, { useState } from 'react';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import { getLoggedInMsisdn } from 'utils/contact-util';
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
import LayoutManager from 'utils/layout-manager';
import t from 'utils/translate';
import classNames from 'classnames';
import { addPhoneNumberPlus, removePhoneNumberPlus } from 'utils/functions';

function PhoneNumberInput({ value, placeholder, onChange, disabled, mandatory, checkNumberFormat, ...otherProps }) {
    placeholder = placeholder ?? t('settings_call_forward_set_external_number');

    const language = LayoutManager.getLanguage().split('_')[0];

    const phoneData = parsePhoneNumberFromString(addPhoneNumberPlus(getLoggedInMsisdn()));

    value = value ? addPhoneNumberPlus(value) : '';

    const [currentVal, setCurrentVal] = useState(value);

    const validNumber = checkNumberFormat ? matchIsValidTel(currentVal) : true;

    return (
        <MuiTelInput
            langOfCountryName={language}
            defaultCountry={phoneData ? phoneData.country : ''}
            placeholder={placeholder}
            value={currentVal}
            disabled={disabled}
            className={classNames({
                PhoneInput: true,
                'with-error': (currentVal && !validNumber) || (!currentVal && mandatory) || otherProps.error,
            })}
            onChange={(v = '') => {
                setCurrentVal(v);

                if (typeof onChange === 'function') {
                    onChange(removePhoneNumberPlus(v));
                }
            }}
            {...otherProps}
        />
    );
}

export default PhoneNumberInput;
